<template>
  <div class="text-text-muted truncate text-2sm">
    <template v-if="!!transaction.transfer_id">
      {{ transferComment }}
    </template>
    {{ comment }}
  </div>
</template>

<script>
export default {
  name: "Comment",
  props: ['comment', 'transaction'],
  computed: {
    transferComment() {
      let acc_name;
      if (!this.transaction.transfer.expense && !this.transaction.transfer.income) {
        acc_name = this.$t('investments') + ': ' + this.transaction.transfer.asset.instrument.name;
      } else {
        acc_name = this.transaction.type === 1 ?
            this.transaction.transfer.expense.account.title :
            this.transaction.transfer.income.account.title;
      }

      return this.transaction.type === 1 || this.transaction.type === 3 ?
          `${this.$t('from')} ${acc_name}` :
          `${this.$t('to')} ${acc_name}`;

    }
  },
  i18n: {
    messages: {
      en: {
        investments: 'investments',
        from: 'From',
        to: 'To'
      },
      ru: {
        investments: 'инвестиции',
        from: 'Из',
        to: 'На'
      }
    }
  }

}
</script>